export const toInteger = (str: string) => parseInt(str, 10)

export const toFloat = (str: string) => parseFloat(str)
